import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openMarketingChannelsSubmenu, openWorkflowsSubmenu } from '../sidebarHelpers';

const activateAbandonedCartWorkflow = (baseUrl, navigate, cartAbandonmentEmail, cartAbandonmentWorkflow) => {
  return {
    id: 'activateAbandonedCartWorkflow',
    title: 'Activate abandoned cart workflow',
    steps: [
      {
        selector: '[data-tour="marketingChannelsLink"]',
        content: <p>Click on the "Marketing Channels" menu item in the navigation.</p>,
      },
      {
        actionBefore: () => openMarketingChannelsSubmenu('[data-tour="emailsLink"]'),
        selector: '[data-tour="emailsLink"]',
        content: <p>Click on the "Emails" in the navigation.</p>,
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/emails?searchTerms=${'[automated] cart abandonment'}`, true);
        },
        selector: '[data-email-name="[Automated] Cart abandonment"]',
        content: (
          <p>
            Abandoned cart workflow allows you to remind your customers when they added a product to their basket but
            did not complete a purchase.
          </p>
        ),
      },
      {
        selector: '[data-email-name="[Automated] Cart abandonment"] [data-tour="emailCardLink"]',
        content: <p>Click on the email name to edit it.</p>,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/emails/${cartAbandonmentEmail.id}/details`, true),
        selector: '[data-tour="emailFormInnerVisualContent"]',
        content: (
          <>
            <p>
              In the visual editor add your logo at the top of the email and change the text to suit your customers.
            </p>
            <p>
              The block with product placeholders is called a product block. This element uses AI to select different
              products for each customer according to a selected algorithm.
            </p>
            <p>
              You should also edit the footer of your email to include your company information and any relevant links
              you might want to include.
            </p>
          </>
        ),
      },
      {
        selector: '[data-tour="emailFormInnerVisualContent"]',
        content: <p>Edit the visual elements in your email.</p>,
        stepInteraction: true,
      },
      {
        selector: '[data-tour="emailFormSaveButton"]',
        content: <p>Click on the "Save" button.</p>,
      },
      {
        actionBefore: () => document.querySelector('[data-tour="emailFormSaveButton"]')?.click(),
        selector: '[data-tour="workFlowsLink"]',
        content: <p>Click on the "Workflows" menu item in the navigation.</p>,
      },
      {
        actionBefore: () => openWorkflowsSubmenu('[data-tour="workflowsContinuousLink"]'),
        selector: '[data-tour="workflowsContinuousLink"]',
        content: <p>Click on the "Continuous" in the navigation.</p>,
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/workflows?mode=continuous&searchTerms=${'cart abandonment'}`, true);
        },
        selector: '[data-workflow-name="Cart abandonment"]',
        content: <p>This is the "Cart abandonment" workflow that you need to activate.</p>,
      },
      {
        selector: '[data-workflow-name="Cart abandonment"] .mantine-Switch-body',
        content: <p>Activate it by clicking the switch button.</p>,
        stepInteraction: true,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: cartAbandonmentWorkflow.running ? true : false,
  };
};

export default activateAbandonedCartWorkflow;
